/*
 * General tools for math operations.
 */

export default {

    /**
     * Rounds any number to the specified decimal places.
     *
     * @param {number} value The value to round.
     * @param {number} roundTo The number of decimal places to use.
     * @returns {number} rounded number.
     */
    round(value, roundTo = 5) {
        return isNaN(value) ? 0 : parseFloat(value.toFixed(roundTo))
    },

    /**
     * Segments a value into well formed currency.
     * @param {number} value The value to segment.
     * @param {string} [currency='£']
     * @param {number} [segmentSize=3] The size of the segments.
     * @param {string} [separator=','] The separator.
     * @returns {string} A currency string.
     */
    segmentCurrency(value, currency = '£', segmentSize = 3, separator = ',') {
        const parts = String(value).split('.')
        const decimals = parts[1]
        const partValue = parts[0].replace(/\D/g, '')
        return `${ currency }${ this.segmentValue(partValue, segmentSize, separator) }${ decimals ? '.' + decimals.substring(0, 2) : '' }`
    },

    /**
     * Segments a value into blocks.
     * @param {number|string} value The value to segment.
     * @param {number} segmentSize The size of the segments.
     * @param {string} separator The separator.
     * @returns {string} A currency string.
     */
    segmentValue(value, segmentSize, separator) {
        const valueStr = String(value)

        const blocks = []
        const remainder = valueStr.length % segmentSize

        if (remainder)
            blocks.push(valueStr.substring(0, remainder))


        for (let i = remainder, charsLength = valueStr.length; i < charsLength; i += segmentSize)
            blocks.push(valueStr.substring(i, i + segmentSize))


        return blocks.join(separator)
    },

}
